import { Component, HostBinding, Input } from "@angular/core";

/**
 * A centered angular material indeterminate spinner.
 */
@Component({
	selector: "dr-centered-indeterminate-spinner",
	templateUrl: "./centered-indeterminate-spinner.component.html",
	styleUrls: ["./centered-indeterminate-spinner.component.scss"],
})
export class CenteredIndeterminateSpinnerComponent {
	/**
	 * Wether to use 'flex-grow: 1' on this component to use all the available space
	 * to center the component vertically.
	 */
	@HostBinding("class.flex-grow") @Input() public flexGrow = false;
}
